import {Action} from '@ngrx/store';
import {type} from '../utilities/type';

export const testDataActionTypes = {
  LOAD: type('[TestData] Load'),
  LOAD_SUCCESS: type('[TestData] Load Success'),
  LOAD_FAIL: type('[TestData] Load Fail'),
  UPDATE: type('[TestData] Update'),
};

export class LoadTestDataAction implements Action {
  readonly type = testDataActionTypes.LOAD;
  constructor() {
  }
}

export class LoadTestDataSuccessAction implements Action {
  readonly type = testDataActionTypes.LOAD_SUCCESS;
  constructor(public payload?: number[]) {
  }
}

export class LoadTestDataFailAction implements Action {
  readonly type = testDataActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {
  }
}

export class UpdateTestDataFailAction implements Action {
  readonly type = testDataActionTypes.UPDATE;
  constructor(public payload: number[]) {
  }
}

